import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluadores: [],
  },

  getters: {
    getEvaluadores: (state) => state.evaluadores,
  },

  mutations: {
    SET_EVALUADORES(state, evaluadores) {
      state.evaluadores = evaluadores;
    },
  },

  actions: {
    async fetchEvaluadores({ commit }, idArea) {
      await axios
        .get(`PoliciaCuadrantes/C3/area/${idArea}/catEvaluador`)
        .then((response) => {
          commit('SET_EVALUADORES', response.data.data);
        });
    },
  },
};
